import OnLoadHelper from '@/scripts/old/helpers/OnLoadHelper';
import { loopElements } from '@/scripts/old/helpers/utils';

class Module {
  constructor(selector) {
    this.$app = null;
    this.initialized = false;
    this.instances = new Map();
    this.selector = selector;

    OnLoadHelper.run(() => {
      this.init();
    });
  }

  init() {
    const els = [];
    loopElements(this.selector, (el) => {
      els.push(el);
      if (!this.instances.get(el)) {
        this.initInstance(el);
      }
    });

    // Loop through all instances and destroy those for which there was no element
    if (this.initialized) {
      this.instances.forEach((instance, el) => {
        if (!els.includes(el)) {
          this.destroyInstance(instance);
          this.instances.delete(el);
        }
      });
    }

    this.initialized = true;
  }

  update() {
    this.init();
  }

  destroy() {
    this.instances.forEach((instance) => this.destroyInstance(instance));
    this.instances.clear();
    this.initialized = false;
  }

  register(app) {
    this.$app = app;
  }

  initInstance(el) {
    console.warn(`initInstance method is empty, el: ${el}`);
  }

  destroyInstance(instance) {
    console.warn(`destroyInstance method is empty, instance: ${instance}`);
  }

  getInstance(el) {
    return this.instances.get(el);
  }
}

export default Module;
